// eslint-disable-next-line @typescript-eslint/triple-slash-reference
/// <reference path="../dist/gui.d.ts" />

export default class TestButton {

    public constructor(app: vf.Application, uiStage: vf.gui.Stage) {
        this.onLoad(app, uiStage)
    }
    private _textInput?: vf.gui.TextInput;
    private _buttonList: vf.gui.Label[] = [];
    private onLoad(app: vf.Application, uiStage: vf.gui.Stage) {

        /** 单行输入 TextInput(false) */
        const textInput = this._textInput = new vf.gui.TextInput(false);
        textInput.style.left = 500;
        textInput.style.top = 300;
        textInput.style.width = 300;
        textInput.style.height = 30;
        textInput.style.fontSize = 24;//"32px"
        textInput.style.fontFamily = "微软雅黑";
        textInput.style.color = 0x00ffcc;
        textInput.placeholder = "单行输入文本...";
        textInput.maxLength = 15;
        textInput.restrict = new RegExp('\\w+');//由数字、26个英文字母或者下划线组成的字符串
        textInput.up = "assets/skin/TextInput/up.png";
        textInput.down = "assets/skin/TextInput/down.png";
        textInput.move = "assets/skin/TextInput/down.png";
        textInput.disabled = "assets/skin/TextInput/disabled.png";
        //textInput.props.enabled = false;
        uiStage.addChild(textInput);


        this.getButton('设置/取消text', () => {
            if (textInput.text !== "Hello World") {
                textInput.text = "Hello World";

            } else {
                textInput.text = "";
            }

        }, uiStage, 15, 0);



        this.getButton('设置/取消placeholder', () => {
            if (textInput.placeholder !== "") {
                textInput.placeholder = "";

            } else {
                textInput.placeholder = "单行输入文本...";
            }

        }, uiStage, 15, 0);


        this.getButton('设置/取消maxLength', () => {
            if (textInput.maxLength !== 0) {
                textInput.maxLength = 0;

            } else {
                textInput.maxLength = 15;
            }

        }, uiStage, 15, 0);

        this.getButton('设置/取消up', () => {
            if (textInput.up !== "") {
                textInput.up = "";

            } else {
                textInput.up = "assets/skin/TextInput/up.png";
            }

        }, uiStage, 15, 0);

        this.getButton('设置/取消down', () => {
            if (textInput.down !== "") {
                textInput.down = "";

            } else {
                textInput.down = "assets/skin/TextInput/down.png";
            }

        }, uiStage, 15, 0);


        this.getButton('设置/取消move', () => {
            if (textInput.move !== "") {
                textInput.move = "";

            } else {
                textInput.move = "assets/skin/TextInput/down.png"
            }

        }, uiStage, 15, 0);

        this.getButton('设置/取消disabled', () => {
            if (textInput.disabled !== "") {
                textInput.disabled = "";

            } else {
                textInput.disabled = "assets/skin/TextInput/disabled.png"
            }

        }, uiStage, 15, 0);


        this.getButton('设置/取消color', () => {
            if (textInput.style.color !== 0xffcc00) {
                textInput.style.color = 0xffcc00;

            } else {
                textInput.style.color = 0x00ffcc;
            }

        }, uiStage, 15, 0);


        this.getButton('设置/取消fontFamily', () => {
            if (textInput.style.fontFamily !== "宋体") {
                textInput.style.fontFamily = "宋体";

            } else {
                textInput.style.fontFamily = "微软雅黑";
            }

        }, uiStage, 15, 0);


        this.getButton('设置/取消fontSize', () => {
            if (textInput.style.fontSize !== 30) {
                textInput.style.fontSize = 30;

            } else {
                textInput.style.fontSize = 24;
            }

        }, uiStage, 15, 0);


        this.getButton('设置/取消restrict', () => {
            if (textInput.restrict !== new RegExp('^[-\\+]?([0-9]+\\.?)?[0-9]+$')) {
                textInput.restrict = new RegExp('^[-\\+]?([0-9]+\\.?)?[0-9]+$');

            } else {
                textInput.restrict = new RegExp('\\w+');
            }

        }, uiStage, 15, 0);

















    }

    private posY = 10;
    private getButton(title: string, clickFun: Function, target: any, x: number, y: number) {
        const button = new vf.gui.Label;
        button.style.fontSize = 24;
        button.style.fontFamily = 'PingFang-SC-Medium,PingFang-S';
        button.style.fontWeight = 500;
        button.style.color = 0xffffff;
        button.style.lineHeight = 45;
        button.text = title;
        button.interactabled = true;
        button.x = x;
        button.y = this.posY;
        button.on(vf.gui.Interaction.TouchMouseEvent.onClick, clickFun);
        target.addChild(button);
        this.posY = this.posY + 25 + y;
        this._buttonList.push(button);
        return button;
    }

    private onRelease() {
        if (this._textInput) {
            this._textInput.removeAllListeners();
            this._textInput.parent && this._textInput.parent.removeChild(this._textInput);
            this._textInput.release();
            this._textInput = undefined;
        }
        if (this._buttonList && this._buttonList.length > 0) {
            this._buttonList.forEach(element => {
                element.removeAllListeners();
                element.parent && element.parent.removeChild(element);
                element.release();
            });
            this._buttonList = [];
        }
    }
}